module.exports = __webpack_public_path__ + "static/media/documentFlip.8649cf51.svg";